







































































import { Component, Vue } from "vue-property-decorator";
import "@/styles/MCQ.scss";
import { GeneralService } from "../services/general-service";
import config from "../services/api-config";
import router from "../router";
import store from "../store";

@Component({
  components: {}
})
export default class PastPapers extends Vue {
  private service = new GeneralService();
  private clId;

  private selected: any = null;
  private selectedYear: any = null;
  private selectedSubject: any = null;

  private entities: GActivity[] = [];
  private boards: Boards[] = [];
  private years: number[] = [2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012];
  private boardId: string = "";
  private yearId: string = "";
  private subjectId: string = "";
  private pastPaperSrc: string = "";
  private is2020: boolean = false;

  private noPaper: boolean = false;

  private showYear: boolean = false;
  private showSubjects: boolean = false;
  private pastPaper: boolean = false;

  private changeYear() {
    this.is2020 = false;
    if (this.yearId !== "" && this.yearId !== "2020") {
      this.showSubjects = true;
    } else if (this.yearId == "2020") {
      this.is2020 = true;
    } 
    else {
      this.showSubjects = false;
    }
  }

  public selectSubject(id, name) {
    this.$store.state.selectSubject = id;
    this.$store.state.selectSubjectName = name;
  }

  mounted() {

    
    var currentYear = new Date().getFullYear();
    this.years = Array.from({ length: 15 }, (_, index) => currentYear - index);

    this.clId = localStorage[config.classLevl];

    if (this.clId == "" || this.clId == undefined || this.clId == "null") {
      router.push("select");
    }

    this.service
      .ppsubjects(this.clId)
      .then(result => {
        this.entities = result.filter(e => e.fullName !== 'Practical');
        this.loadBoards(this.clId);
      })
      .catch(err => {
        console.error(`Error: ${err.message}`);
      });

    this.changeYear();
  }

  boardSelected(evt) {
    this.showYear = true;
    this.boardId = evt.target.value;
    this.selected = this.boardId;
    this.viewPassPapers(this.subjectId + ':' + this.yearId);
  }

  yearSelected(evt) {
    this.yearId = evt.target.value;
    this.selectedYear = this.yearId;
    this.changeYear();
    this.viewPassPapers(this.subjectId + ':' + this.yearId);
  }

  subjectSelected(evt) {
    this.subjectId = evt.target.value;
    this.viewPassPapers(evt.target.value + ':' + this.yearId);
  }

  private viewPassPapers(param) {
    if (this.boardId != "" && this.yearId != "") {
      this.service
        .getPdf(this.boardId + ":" + param)
        .then(result => {
          this.pastPaper = true;
          this.noPaper = false;
          if (result[0] == null){
            this.noPaper = true;
          } else {
            this.pastPaperSrc = result[0].paperpath;
          }
        })
        .catch(err => {
          console.error(`Error: ${err.message}`);
        });
    } else {
      if (this.boardId == "") {
        console.error("Please Select a Board");
      } else {
        console.error("Please Select a Year");
      }
    }
  }

  private loadBoards(clId) {
    this.service
      .boardsAll(clId)
      .then(result => {
        this.boards = result;
      })
      .catch(err => {
        console.error(`Error: ${err.message}`);
      });

    this.changeYear();
  }
}
